import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { cloudinaryUrl } from '../../lib/cloudinary';
import { Category, categoryLabels } from '../../data/products';

interface CategoryTileProps {
  category: Category;
  imageId: string;
}

const Tile = styled(Link)`
  position: relative;
  display: block;
  overflow: hidden;
  aspect-ratio: 1 / 1;
  color: ${({ theme }) => theme.colors.background};

  &:hover img {
    opacity: 0.85;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity ${({ theme }) => theme.transitions.short};
`;

const Label = styled.span`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${({ theme }) => theme.fonts.accent};
  font-size: 2rem;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.background};
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.35);
  pointer-events: none;
`;

const CategoryTile: React.FC<CategoryTileProps> = ({ category, imageId }) => (
  <Tile to={`/collections/${category}`} aria-label={categoryLabels[category]}>
    <Image
      src={cloudinaryUrl(imageId, { width: 800, aspectRatio: '1:1' })}
      alt=""
      loading="lazy"
    />
    <Label>{categoryLabels[category]}</Label>
  </Tile>
);

export default CategoryTile;
